module.exports = __webpack_public_path__ + "img/ph.6ae85442.svg";